<!-- 首页组件 - 重构版本 -->
<template>
  <CommonPages id="home" :class="homeClass" :titlePrefix="pageMetaTitle"
    :metaDescription="pageMetaDescription">

    <!-- Hero区域（移动端 home_1 在 Collections 按钮下方，由 HomeHero 内部承载） -->
    <HomeHero :mobileCollectionsAd="deviceType == 'mobile' ? bodyHomeAds.home_1 : null" />

    <!-- 广告位 1（仅PC，Hero 背景大图下方） -->
    <AdComponent v-if="deviceType != 'mobile'" ref="ads-home-1" class="ad-width-100 m_padding pc_padding home-ad-pc-180"
      :ads="bodyHomeAds.home_1" :showDebug="showDebug" :forceDebug="true" debugLabel="home_1"
      debugPosition="首屏背景大图下方（仅PC）" />

    <!-- 地区卡片（内部承载 home_2/home_3） -->
    <HomeRegionCards :adHome2="bodyHomeAds.home_2" :adMobileMap="bodyHomeAds.home_3"
      :showAdDebug="showDebug" />

    <HomeLivingStandards :showAdDebug="showDebug" />

    <!-- 广告位 3（仅PC，Where Do You Belong? 上方） -->
    <AdComponent v-if="deviceType != 'mobile'" ref="ads-home-3-pc-top"
      class="ad-width-100 pc_padding home-ad-pc-180" :ads="bodyHomeAds.home_3"
      :showDebug="showDebug" :forceDebug="true" debugLabel="home_3"
      debugPosition="Where Do You Belong? 上方（仅PC）" />

    <!-- 广告位 4（仅移动端，Where Do You Belong? 模块上方） -->
    <AdComponent v-if="deviceType == 'mobile'" ref="ads-home-4-mobile-top"
      class="ad-width-100 m_padding pc_padding home-ad-pc-180"
      :ads="bodyHomeAds.home_4" :showDebug="showDebug" :forceDebug="true" debugLabel="home_4"
      debugPosition="Where Do You Belong? 模块上方（仅移动端）" />

    <!-- 城市匹配器 -->
    <HomeWhereYouBelong :budgetTopAd="deviceType == 'mobile' ? bodyHomeAds.home_5 : null"
      :showAdDebug="showDebug" />

    <!-- 广告位 4（仅PC，The Deep Dive 模块上方） -->
    <AdComponent v-if="deviceType != 'mobile'" ref="ads-home-4-pc-top"
      class="ad-width-100 pc_padding home-ad-pc-180" :ads="bodyHomeAds.home_4"
      :showDebug="showDebug" :forceDebug="true" debugLabel="home_4"
      debugPosition="The Deep Dive 模块上方（仅PC）" />

    <!-- 博客文章区域（内部中插广告） -->
    <HomeDeepDive :mobileInlineAds="homeBlogMobileAds" :showAdDebug="showDebug" />

    <!-- 广告位 5（仅PC，名言区上方） -->
    <AdComponent v-if="deviceType != 'mobile'" ref="ads-home-5-pc-top"
      class="ad-width-100 pc_padding home-ad-pc-180" :ads="bodyHomeAds.home_5"
      :showDebug="showDebug" :forceDebug="true" debugLabel="home_5"
      debugPosition="名言区上方（仅PC）" />

    <!-- 名人引用区域 -->
    <HomeVoicesQuote />

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';

// 核心组件
import CommonPages from '@/pages/components/page_common.vue'
import AdComponent from '@/pages/components/AdComponent.vue'

// Home页面组件
import HomeHero from '@/components/home/HomeHero.vue'
import HomeRegionCards from '@/components/home/HomeRegionCards.vue'
import HomeLivingStandards from '@/components/home/HomeLivingStandards.vue'
import HomeWhereYouBelong from '@/components/home/HomeWhereYouBelong.vue'
import HomeDeepDive from '@/components/home/HomeDeepDive.vue'
import HomeVoicesQuote from '@/components/home/HomeVoicesQuote.vue'
import { getContentTextMap, getText } from '@/utils/contentText'
import { getRenderableAd } from '@/utils/adConfig'

// 样式
import '@/css/home.scss';
import '@/css/common.scss';

const HOME_AD_KEYS = ['home_1', 'home_2', 'home_3', 'home_4', 'home_5']

export default {
  name: 'Home',
  components: {
    CommonPages,
    AdComponent,
    HomeHero,
    HomeRegionCards,
    HomeLivingStandards,
    HomeWhereYouBelong,
    HomeDeepDive,
    HomeVoicesQuote
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      // 数据可以在这里添加
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'showDebug'
    ]),
    homeAds () {
      return HOME_AD_KEYS.reduce((ads, key) => {
        ads[key] = getRenderableAd(this.adsensConfig?.[key])
        return ads
      }, {});
    },
    bodyHomeAds () {
      // 2026-08-19 t103644 followup: 按表格 FZ5eG2/6B4tQf 恢复 home_5 原位（mobile Budget 筛选上方 / PC 名言区上方），
      // 移除 fb22dd6 的「最后一个广告位挪首页顶部」覆盖逻辑
      return this.homeAds
    },
    homeClass () {
      return ['home']
    },
    debugVisible () {
      return this.showDebug || String(this.$route?.query?.db || '') === '1'
    },
    homeBlogMobileAds () {
      return {
        ad1: null,
        ad3: null,
        ad5: null
      };
    },
    contentText () {
      return getContentTextMap(this.domainConfig)
    },
    pageMetaTitle () {
      return getText(this.contentText, 'HOME_META_TITLE', 'Home')
    },
    pageMetaDescription () {
      return getText(this.contentText, 'HOME_META_DESCRIPTION', 'Discover the 50 most livable cities around the world')
    }
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component mounted`);
    }

    // Manually report page view for home page to ensure it happens before ad initialization
    await this.reportPageView();
    // The new adMixin handles its own initialization, so these calls are no longer needed here.
    // await this.initAdSystem();
    // this.$nextTick(() => {
    //   this.initAdTracking();
    // });
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component beforeDestroy`);
    }
  }
};
</script>
